import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PersonState } from '../../../../../core/states/offer/offer.state';
import { Observable } from 'rxjs';
import { GenderIcon, PersonService } from '../../../../../core/services/person.service';

@Component({
  standalone: false,
  selector: 'ssc-single-person-item',
  templateUrl: './single-person-item.component.html',
  styleUrls: ['./single-person-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SinglePersonItemComponent {
  @Input() public person: PersonState;
  @Input() public basketIsOpen = false;

  constructor(private personService: PersonService) {}

  public getFirstNameOrFallback$(): Observable<string> {
    return this.personService.getFirstNameOrFallback$(this.person.details.firstName, this.person.personId);
  }

  public getIconName$(): Observable<GenderIcon> {
    return this.personService.getIconForGender$(this.person.details.genderOrPrenatal, this.person.details.dateOfBirth);
  }
}
